import { DatePipe } from '@angular/common';
import { Component, OnInit, TemplateRef } from '@angular/core';
import { NgForm } from '@angular/forms';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { defineLocale } from 'ngx-bootstrap/chronos';
import { BsLocaleService } from 'ngx-bootstrap/datepicker';
import { enGbLocale } from 'ngx-bootstrap/locale';
import { BsModalService } from 'ngx-bootstrap/modal';
import { ToastrService } from 'ngx-toastr';
import { environment } from '../../shared/config/app-config';
import { ConformComponent } from '../../conform/conform.component';
import { PatientService, UserService } from '../../shared';

@Component({
  selector: 'app-security',
  templateUrl: './security.component.html',
  styleUrls: ['../style.component.css', './security.component.css']
})
export class SecurityComponent implements OnInit {
  language: any;
  cpName: string;
  helpDeskNo: any;
  dobvalid: boolean;
  patid: any;
  maxdate: boolean;
  mindate: boolean;
  showinvaild1: boolean;
  dateform: any;
  public dateformat = environment.dateFormat;
  public bsConfig = Object.assign({}, { containerClass: 'theme-dark-blue', showWeekNumbers: false, dateInputFormat: this.dateformat });
  showinvaild: boolean = false
  patname: any = '';
  public timealert = environment.timelimit;
  public user: any = {
    dob: '',
  }
  public bobMaxDate = new Date();
  welcome: any;
  modalRef: any;
  expires: MatDialogRef<ConformComponent>;
  public datenew = new Date("01/01/1800");
  resdata: any;
  userName: any;
  patientId: any;
  notmatched: boolean = false;
  openModal(template: TemplateRef<any>) {
    this.modalRef = this.modalService.show(template, { class: 'modal-sm', backdrop: 'static' });
  }
  constructor(
    public datepipe: DatePipe,
    private toastr: ToastrService,
    private patientservice: PatientService,
    private userService: UserService,
    private routerr: ActivatedRoute,
    private modalService: BsModalService,
    private nav: Router,
    private dialog: MatDialog,
    private localeService: BsLocaleService

  ) {
    enGbLocale.invalidDate = '';
    enGbLocale.weekdaysShort = ['S', 'M', 'T', 'W', 'T', 'F', 'S'];
    enGbLocale.week.dow = 0;
    defineLocale('custom locale', enGbLocale);
    this.localeService.use('custom locale');
  }
  allowPassChange: boolean = false
  ngOnInit() {


    this.patid = window.localStorage['randId']
    this.patientservice.changeNav(window.localStorage['randId'])
    if (window.localStorage['mail']) {
      this.userService.forgotUserInfo(window.localStorage['mail'])
        .subscribe(
          data1 => {
            if (data1) {
              this.patname = data1.firstName + ' ' + data1.lastName;
              if (data1.patFirstName) {
                this.cpName = data1.patFirstName + ' ' + data1.patLastName
              }
              this.userName = window.localStorage['mail']
              this.patientId = data1.patientId
              this.allowPassChange = data1.allowPasswordChange
              this.helpDeskNo = data1.helpDeskNo ? data1.helpDeskNo : '1-630-560-6805'
              this.language = data1.countryCode ? data1.countryCode : 'USA'
              window.localStorage['status'] = 'forgotlink'
              if (data1.dateFormat == 'DDMMYYYY') {
                this.dateformat = 'DD/MM/YYYY'
                this.dateform = 'dd/MM/yyyy'

                this.patientservice.us_Patient = false;

                if (navigator.userAgent.search("iPhone") != -1) {
                  this.nav.navigateByUrl('/appstore')
                }
              } else {
                this.dateformat = 'MM/DD/YYYY'
                this.dateform = environment.dateFormat
                if (navigator.userAgent.search("iPhone") != -1) {
                  this.nav.navigateByUrl('/appstore')
                  location.href = "https://apps.apple.com/us/app/rc-coach/id1475273242";
                }
              }
              this.bsConfig = { containerClass: 'theme-dark-blue', showWeekNumbers: false, dateInputFormat: this.dateformat }
            }
          }
        );
    }
  }


  checkinvaild(id) {
    // ////console.log("id",id)
    if (id == "Invalid Date") {
      this.showinvaild = true;


    } else {
      this.showinvaild = false
    }
  }
  saveUser(userForm: NgForm, result) {
    //////console.log("result",result.value);

    this.user.dob = this.datepipe.transform(this.user.dob, 'yyyy-MM-dd');
    // ////console.log("dob",this.user.dob)
    this.patientservice
      .validateDOB(this.userName, this.patientId, this.user.dob)
      .subscribe(
        data => {

          //////console.log(data);
          if (data.status == "success") {

            this.nav.navigate([`/uservalidate`])
          }
          else if (data.status == "failure") {

            this.notmatched = true;
            userForm.reset();
          }
          else {
            this.resdata = "Unauthorized Access";
            this.modalRef = this.modalService.show(result, { class: 'modal-sm', backdrop: "static" });

          }
        }
      );

  }
  dateValueChange(event) {
    if (event.keyCode != 8) {
      if (event.target.value.length == 2 || event.target.value.length == 5) {
        var thisVal = event.target.value;
        thisVal += '/';
        event.target.value = thisVal;
      }
    }
    if (event.target.value.length == 10) {
      this.dobvalid = true
    } else {
      this.dobvalid = false
    }
  }
  checkdate(id) {
    if (id == '' || id == null || id == 'Invalid Date') {
      this.mindate = true;
    }
    else {

      let date
      if (id != 'Invalid Date')
        date = this.datepipe.transform(id, 'yyyy-MM-dd');
      let curentdate = this.datepipe.transform(new Date(), 'yyyy-MM-dd');
      if (date <= "1800-01-01") {

        this.mindate = true;
        this.maxdate = false;
        this.notmatched = false
      }
      else if (date > curentdate) {
        this.mindate = false;
        this.maxdate = true;
        this.notmatched = false
      }
      else if (date >= "1800-01-01" && date < curentdate) {
        this.mindate = false;
        this.maxdate = false;

      }
      else {
        this.mindate = false;
      }
    }
  }

  checkempty1(id) {

    let date
    if (id != 'Invalid Date')
      date = this.datepipe.transform(id, 'yyyy-MM-dd');
    let curentdate = this.datepipe.transform(new Date(), 'yyyy-MM-dd');
    if (id == '' || id == null || id == 'Invalid Date') {

      this.showinvaild1 = true;
      this.mindate = false;
      this.maxdate = false;
    } else if (id != '' && id != null && date <= "1800-01-01") {
      this.mindate = true;
      this.showinvaild1 = false;
      this.maxdate = false;
    } else if (id != '' && id != null && date > curentdate) {
      this.maxdate = true;
      this.showinvaild1 = false;
      this.mindate = false;
    } else {
      this.showinvaild1 = false;
      this.mindate = false;
      this.maxdate = false;
    }

  }

}